import { t } from 'i18next';

import { AgentMessageEventThoughtData } from '../../../../gamma-api';

export const printAgentReflections = (data: AgentMessageEventThoughtData): string => {
  const content = data.content;
  if (typeof content === 'string') {
    return content;
  }

  if (content.thought && content.action == 'handoff') {
    return `${content.thought} ${t('Agent: Testing chat: Reason to handoff')}: ${content.action_input?.reason}`;
  }

  if (content.thought) {
    return content.thought;
  }

  return JSON.stringify(data.content);
};
